// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/brasao_piaui.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  overflow: hidden;
}

.login-container::before {
  content: '';
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  width: min(65vw, 900px);
  aspect-ratio: 418 / 458;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  opacity: 0.1;
  pointer-events: none;
  z-index: 0;
}

@media (max-width: 700px) {

.login-container::before {
    width: 90vw;
}
  }


.content-form {
  position: relative;
  z-index: 1;
  width: 50%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}


@media (max-width: 700px) {


.content-form {
    width: 95%;
}
  }

.login-box {
  width: 80%;
  max-width: 600px;
}

@media (max-width: 500px) {

.login-box {
    width: 95%;
}
  }

.login-box  > form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 40px 40px 90px 40px;
    width: 100%;
    border-radius: 30px;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  }

:is(.login-box > form)  > img {
      width: 120px;
      margin: 0 auto;
      margin-bottom: 20px;
    }



.login-container button {
  border: none;
  border-radius: 20px;
  padding: 10px;
  height: 40px;
  margin-top: 10px;
  font-size: 16px;
  cursor: pointer;
}

/* Campo "isca" (honeypot): fica fora da tela, usuário nunca vê nem usa.
   Robôs que preenchem tudo automaticamente caem nele e o login é recusado. */
.login-hp-field {
  position: absolute !important;
  left: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}

/* Aviso de bloqueio temporário / conta bloqueada / alerta antes do bloqueio. */
.login-lock-message {
  color: #b23b3b;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  margin: 4px 0 0 0;
}

/* Aviso para quem entrou no login por engano (visitantes). */
.login-visitor-notice {
  margin: 6px 0 0 0;
  padding: 8px 10px;
  border-radius: 10px;
  background: #f2f4f7;
  color: #3a3f47;
  border: 1px solid #d7dbe0;
  font-size: 12px;
  text-align: center;
  line-height: 1.4;
}

.login-visitor-notice a {
  color: var(--azul);
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 3px;
}

/* CSS do showpassword */
.password-input {
  position: relative;
}

.eye-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  color: var(--azul) !important;
  opacity: .9;
  transform: translateY(-50%);
  cursor: pointer;
}

.btn-login{
  border: 1px solid var(--azul) !important;
  max-width: 150px;
}

.btn-login:disabled {
  opacity: .75;
  cursor: not-allowed;
}

.btn-login-loading {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn-login-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(38, 93, 175, 0.25);
  border-top-color: var(--azul);
  border-radius: 50%;
  animation: login-spin .8s linear infinite;
}

@keyframes login-spin {
  to {
    transform: rotate(360deg);
  }
}

.login-training-badge {
  margin: 0 0 8px 0;
  padding: 6px 10px;
  border-radius: 10px;
  background: #fff3cd;
  color: #7a5d00;
  border: 1px solid #ffe08a;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.3px;
}

.login-production-link-badge {
  margin: 0 0 8px 0;
  padding: 6px 10px;
  border-radius: 10px;
  background: #eaf4ff;
  color: #0b3f79;
  border: 1px solid #9fc2ea;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  display: block;
}

.login-production-link-badge:hover {
  background: #dfeeff;
}

.login-support-link {
  margin-top: 40px;
  text-decoration: none;
  color: var(--azul);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 700;
  font-style: italic;
  text-decoration: underline;
  text-underline-offset: 4px;
  opacity: .9;
}

.login-support-link:hover {
  opacity: 1;
}

.login-support-icon {
  width: 18px;
  height: 18px;
  opacity: .9;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/login.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,yDAAoD;EACpD,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;EAC3B,YAAY;EACZ,oBAAoB;EACpB,UAAU;AAKZ;;AAHE;;AAhBF;IAiBI,WAAW;AAEf;EADE;;;AAIF;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AAKxB;;;AAHE;;;AAXF;IAYI,UAAU;AAEd;EADE;;AAGF;EACE,UAAU;EACV,gBAAgB;AAsBlB;;AApBE;;AAJF;IAKI,UAAU;AAmBd;EAlBE;;AAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,4BAA4B;IAC5B,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,uCAAuC;EAOzC;;AALE;MACE,YAAY;MACZ,cAAc;MACd,mBAAmB;IACrB;;;;AAMJ;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;6EAC6E;AAC7E;EACE,6BAA6B;EAC7B,aAAa;EACb,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;;AAEA,+EAA+E;AAC/E;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,6DAA6D;AAC7D;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,6BAA6B;EAC7B,WAAW;EACX,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,6BAA6B;EAC7B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb","sourcesContent":[".login-container {\n  position: relative;\n  width: 100%;\n  min-height: 100vh;\n  background-color: #fff;\n  overflow: hidden;\n}\n\n.login-container::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n  width: min(65vw, 900px);\n  aspect-ratio: 418 / 458;\n  background-image: url(../../assets/brasao_piaui.png);\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center;\n  opacity: 0.1;\n  pointer-events: none;\n  z-index: 0;\n\n  @media (max-width: 700px) {\n    width: 90vw;\n  }\n}\n\n\n.content-form {\n  position: relative;\n  z-index: 1;\n  width: 50%;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n\n  @media (max-width: 700px) {\n    width: 95%;\n  }\n}\n\n.login-box {\n  width: 80%;\n  max-width: 600px;\n\n  @media (max-width: 500px) {\n    width: 95%;\n  }\n\n  >form {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 40px 40px 90px 40px;\n    width: 100%;\n    border-radius: 30px;\n    background-color: #fff;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n\n    >img {\n      width: 120px;\n      margin: 0 auto;\n      margin-bottom: 20px;\n    }\n  }\n}\n\n\n\n.login-container button {\n  border: none;\n  border-radius: 20px;\n  padding: 10px;\n  height: 40px;\n  margin-top: 10px;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n/* Campo \"isca\" (honeypot): fica fora da tela, usuário nunca vê nem usa.\n   Robôs que preenchem tudo automaticamente caem nele e o login é recusado. */\n.login-hp-field {\n  position: absolute !important;\n  left: -9999px;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* Aviso de bloqueio temporário / conta bloqueada / alerta antes do bloqueio. */\n.login-lock-message {\n  color: #b23b3b;\n  font-size: 13px;\n  font-weight: 600;\n  text-align: center;\n  margin: 4px 0 0 0;\n}\n\n/* Aviso para quem entrou no login por engano (visitantes). */\n.login-visitor-notice {\n  margin: 6px 0 0 0;\n  padding: 8px 10px;\n  border-radius: 10px;\n  background: #f2f4f7;\n  color: #3a3f47;\n  border: 1px solid #d7dbe0;\n  font-size: 12px;\n  text-align: center;\n  line-height: 1.4;\n}\n\n.login-visitor-notice a {\n  color: var(--azul);\n  font-weight: 700;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n/* CSS do showpassword */\n.password-input {\n  position: relative;\n}\n\n.eye-icon {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  color: var(--azul) !important;\n  opacity: .9;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n\n.btn-login{\n  border: 1px solid var(--azul) !important;\n  max-width: 150px;\n}\n\n.btn-login:disabled {\n  opacity: .75;\n  cursor: not-allowed;\n}\n\n.btn-login-loading {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.btn-login-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(38, 93, 175, 0.25);\n  border-top-color: var(--azul);\n  border-radius: 50%;\n  animation: login-spin .8s linear infinite;\n}\n\n@keyframes login-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.login-training-badge {\n  margin: 0 0 8px 0;\n  padding: 6px 10px;\n  border-radius: 10px;\n  background: #fff3cd;\n  color: #7a5d00;\n  border: 1px solid #ffe08a;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: center;\n  letter-spacing: 0.3px;\n}\n\n.login-production-link-badge {\n  margin: 0 0 8px 0;\n  padding: 6px 10px;\n  border-radius: 10px;\n  background: #eaf4ff;\n  color: #0b3f79;\n  border: 1px solid #9fc2ea;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: center;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  display: block;\n}\n\n.login-production-link-badge:hover {\n  background: #dfeeff;\n}\n\n.login-support-link {\n  margin-top: 40px;\n  text-decoration: none;\n  color: var(--azul);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  font-style: italic;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n  opacity: .9;\n}\n\n.login-support-link:hover {\n  opacity: 1;\n}\n\n.login-support-icon {\n  width: 18px;\n  height: 18px;\n  opacity: .9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
